import React from 'react';
import SquadDetailsPageInner from '../domains/squads/components/SquadDetailsPage';

const SquadDetailsPage: React.FC = () => {
  return <SquadDetailsPageInner mode="teacher" />;
};

export default SquadDetailsPage;

